import { api } from '../api';
import type { BalancaDoEnsaio } from './triviais';

/**
 * As chamadas da compactação, com os caminhos escritos por extenso.
 *
 * Mesmo motivo dos outros: o caminho é o contrato entre a tela e a API, e
 * contrato se lê. Quem procurar `/compactacao/pontos` no projeto acha
 * esta linha, e o teste `26` — que confere se toda rota de criação tem
 * caminho na interface — consegue enxergá-la.
 */

export interface EnsaioCompactacao {
  cabecalho: any;
  pontos: any[];
  umidades: any[];
  equipamentos: any[];
  tabelaNorma?: any[];
  /** Os coeficientes de `compactacao_curva` (0022) — para desenhar. */
  curva?: any;
  /** A balança do cilindro com solo (RN-215). */
  balanca: BalancaDoEnsaio | null;
  /** A balança das cápsulas dos pontos (RN-215). */
  balancaUmidade: BalancaDoEnsaio | null;
  pendencias: string[];
  pendenciasDetalhadas?: any[];
  /** A tentativa da repetição aberta, se houver (onda 323). */
  repeticaoAberta?: number | null;
}

export const verCompactacao = (id: string) =>
  api<EnsaioCompactacao>(`/ensaios/${id}/compactacao`);

export const gravarCompactacaoCabecalho = (id: string, corpo: unknown) =>
  api<EnsaioCompactacao>(`/ensaios/${id}/compactacao`,
    { metodo: 'PUT', corpo });

export const gravarCompactacaoPontos = (id: string, corpo: unknown) =>
  api<EnsaioCompactacao>(`/ensaios/${id}/compactacao/pontos`,
    { metodo: 'POST', corpo });

export const descartarCompactacaoPonto = (
  id: string, pid: string, motivo: string,
) =>
  api<EnsaioCompactacao>(`/ensaios/${id}/compactacao/pontos/${pid}/descartar`,
    { metodo: 'POST', corpo: { motivo } });

export const gravarCompactacaoUmidades = (
  id: string, pid: string, corpo: unknown,
) =>
  api<EnsaioCompactacao>(`/ensaios/${id}/compactacao/pontos/${pid}/umidades`,
    { metodo: 'POST', corpo });

export const descartarCompactacaoUmidade = (
  id: string, uid: string, motivo: string,
) =>
  api<EnsaioCompactacao>(`/ensaios/${id}/compactacao/umidades/${uid}/descartar`,
    { metodo: 'POST', corpo: { motivo } });

/** Um ISC moldado na compactação (onda 323): quem a adoção leva junto. */
export interface IscDaCompactacao {
  id: string;
  status: string;
  amostra_codigo: string | null;
  amostra_identificacao: string | null;
  metodo_codigo: string | null;
  /** A tentativa vigente do ISC. */
  tentativa: number;
  /** A repetição aberta no próprio ISC, se houver: a adoção é recusada. */
  repeticao_aberta: number | null;
  corpos: number;
}

export const verIscsDaCompactacao = (id: string) =>
  api<IscDaCompactacao[]>(`/ensaios/${id}/compactacao/iscs`);
